import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { TokenService } from '../shared/services/token.service';
@Injectable({ providedIn: 'root' })
export class UsageHistoryService {
  constructor(protected http: HttpClient, protected tokenService: TokenService) { }
  createHeader(): HttpHeaders {
    let token = this.tokenService.getLoggedToken();
    if (token)
      return new HttpHeaders({ 'Authorization': 'Bearer ' + token, 'content-type': 'application/json' });
    else
      return new HttpHeaders({ 'content-type': 'application/json' });
  }
  public getCovenants(params: string) {
    let url = environment.portalApi + '/legalperson/convenants?name=' + params;
    return this.http.get(url, { headers: this.createHeader() });
  }
}
